"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var composeValidators_1 = __importDefault(require("../../../helpers/composeValidators"));
var isRequired_1 = __importDefault(require("../../../validators/isRequired"));
var max_1 = __importDefault(require("../../../validators/max"));
var min_1 = __importDefault(require("../../../validators/min"));
var maxLength_1 = __importDefault(require("../../../validators/maxLength"));
var minLength_1 = __importDefault(require("../../../validators/minLength"));
var resolveValidation = function (schema, extras, validations) {
    var required = schema.required, minValue = schema.minValue, maxValue = schema.maxValue, maxLengthValue = schema.maxLengthValue, minLengthValue = schema.minLengthValue;
    var standarValidations = [];
    if (required) {
        standarValidations.push(isRequired_1.default(required.errorMessage));
    }
    if (maxValue || maxValue === 0) {
        standarValidations.push(max_1.default(maxValue, schema.max.errorMessage));
    }
    if (minValue || minValue === 0) {
        standarValidations.push(min_1.default(minValue, schema.min.errorMessage));
    }
    if (maxLengthValue || maxLengthValue === 0) {
        standarValidations.push(maxLength_1.default(maxLengthValue, schema.maxLength.errorMessage));
    }
    if (minLengthValue || minLengthValue === 0) {
        standarValidations.push(minLength_1.default(minLengthValue, schema.minLength.errorMessage));
    }
    var customValidations = Object.keys(extras)
        .filter(function (extraProp) { return validations[extraProp] && typeof validations[extraProp] === 'function'; })
        .map(function (validate) { return function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return validations[validate].apply(validations, __spreadArrays(params, [extras[validate]]));
    }; });
    return composeValidators_1.default.apply(void 0, __spreadArrays(standarValidations, customValidations));
};
exports.default = resolveValidation;
//# sourceMappingURL=resolveValidation.js.map